// removed by extract-text-webpack-plugin
module.exports = {"glide_back_right":"src-components----glider-module---glide_back_right---3rkJj","glide_back_left":"src-components----glider-module---glide_back_left---12Wvz"};


//////////////////
// WEBPACK FOOTER
// ./src/components/glider.module.css
// module id = 108
// module chunks = 161653746587813 263910228981220